type TranslateFn = (key: string) => string;

export enum ImageType {
  PHOTO = 'Photo',
  PLAN = 'Plan',
  INTERIOR = 'Interior',
  DETAIL = 'Detail'
}

export interface ImageTypeOption {
  value: string;
  label: string;
  icon: string;
}

const IMAGE_TYPE_ICONS: Record<ImageType, string> = {
  [ImageType.PHOTO]: 'fa-camera',
  [ImageType.PLAN]: 'fa-map-location-dot',
  [ImageType.INTERIOR]: 'fa-house',
  [ImageType.DETAIL]: 'fa-magnifying-glass',
};

export const getImageTypeOptions = (t: TranslateFn): ImageTypeOption[] => [
  {value: ImageType.PHOTO, label: t('admin.common.images.imageTypes.Photo'), icon: IMAGE_TYPE_ICONS[ImageType.PHOTO]},
  {value: ImageType.PLAN, label: t('admin.common.images.imageTypes.Plan'), icon: IMAGE_TYPE_ICONS[ImageType.PLAN]},
  {
    value: ImageType.INTERIOR,
    label: t('admin.common.images.imageTypes.Interior'),
    icon: IMAGE_TYPE_ICONS[ImageType.INTERIOR]
  },
  {
    value: ImageType.DETAIL,
    label: t('admin.common.images.imageTypes.Detail'),
    icon: IMAGE_TYPE_ICONS[ImageType.DETAIL]
  },
];

export const getImageTypeIcon = (imageType: string | undefined): string => {
  return IMAGE_TYPE_ICONS[imageType as ImageType] || 'fa-image';
};

export const getImageTypeLabel = (imageType: string | undefined, t: TranslateFn): string => {
  if (!imageType) return 'Unknown';
  const key = `admin.common.images.imageTypes.${imageType}`;
  const translated = t(key);
  // Fall back to the raw value if the key isn't found
  return translated !== key ? translated : imageType;
};
